import { actions } from '../constants/reports';
import { UserType } from '../../models/enums/userType';

export function getDailyVisitorsAction(startDate?: Date, endDate?: Date, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        startDate,
        endDate,
        timestamp: Date.now(),
        type: actions.GET_DAILY_VISITORS,
        spinnerId,
        spinnerType
    };
}

export function setDailyVisitorsAction(reportData: any, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        reportData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_DAILY_VISITORS
    };
}

export function getStudentVisitorsAction(startDate?: Date, endDate?: Date, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        startDate,
        endDate,
        timestamp: Date.now(),
        type: actions.GET_STUDENT_VISITORS,
        spinnerId,
        spinnerType
    };
}

export function setStudentVisitorsAction(reportData: any, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        reportData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_STUDENT_VISITORS
    };
}

export function getActiveStudentsAction(take: number, skip: number, userType?: UserType, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        take,
        skip,
        userType,
        timestamp: Date.now(),
        type: actions.GET_ACTIVE_STUDENTS,
        spinnerId,
        spinnerType
    };
}

export function setActiveStudentsAction(reportData: any, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        reportData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_ACTIVE_STUDENTS
    };
}

export function getTotalVisitorsAction(startDate?: Date, endDate?: Date, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        startDate,
        endDate,
        timestamp: Date.now(),
        type: actions.GET_TOTAL_VISITORS,
        spinnerId,
        spinnerType
    };
}

export function setTotalVisitorsAction(reportData: any, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        reportData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_TOTAL_VISITORS
    };
}

export function getVirtualClassStatsAction(startDate?: Date, endDate?: Date, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        startDate,
        endDate,
        timestamp: Date.now(),
        type: actions.GET_VIRTUAL_CLASS_VIEW_STATS,
        spinnerId,
        spinnerType
    };
}

export function setVirtualClassStatsAction(reportData: any, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        reportData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_VIRTUAL_CLASS_VIEW_STATS
    };
}

export function getFrequentlyVisitedCoursesAction(take: number, skip: number, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        take,
        skip,
        timestamp: Date.now(),
        type: actions.GET_FREQUENTLY_VISITED_COURSES,
        spinnerId,
        spinnerType
    };
}

export function setFrequentlyVisitedCoursesAction(reportData: any, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        reportData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_FREQUENTLY_VISITED_COURSES
    };
}

export function getRedirectToAlmsActivityAndExamReportUrlAction(urlReturnType: string | undefined, activityId: string | undefined, classId?: string | undefined, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        urlReturnType,
        activityId,
        classId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_REDIRECT_TO_ALMS_ACTIVITY_AND_EXAM_REPORT_URL,
    };
}
